import script from "./CheckOutFlowNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckOutFlowNotes.vue?vue&type=script&setup=true&lang=js"

import "./CheckOutFlowNotes.vue?vue&type=style&index=0&id=78974a8a&scoped=true&lang=css"
import "./CheckOutFlowNotes.vue?vue&type=style&index=1&id=78974a8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78974a8a"]])

export default __exports__